// @ts-nocheck
import * as addPanel from '@/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_page'],
      sections: [addPanel.sections.getSections().page.pageStyleSection],
    };
  },
};
